// @flow
import constants from '../../constants/styles';
const {
  MAP_POLYGON_LINE_COLOR,
  MAP_POLYGON_LINE_CIRCLE_COLOR,
  MAP_AREA_POLYGON_LINE_COLOR,
  MAP_AREA_POLYGON_LINE_CIRCLE_COLOR,
  MAP_POINT_COLOR,
  MAP_POINT_GPS_COLOR,
  MAP_POINT_WIFI_COLOR,
  MAP_POINT_CELLID_COLOR,
  MAP_POINT_BORDER,
  MAP_POINT_SELECTED_BORDER,
  MAP_TEXT_COLOR,
  MAP_PATH_COLOR
} = constants;

let styles = {
  polygonFill: {
    'fill-color': MAP_POLYGON_LINE_COLOR,
    'fill-opacity': 0.1
  },
  polygonBorder: {
    'line-width': 6,
    'line-color': MAP_POLYGON_LINE_COLOR
  },
  areaFill: {
    'fill-color': MAP_AREA_POLYGON_LINE_COLOR,
    'fill-opacity': 0.1
  },
  areaBorder: {
    'line-width': 6,
    'line-color': MAP_AREA_POLYGON_LINE_COLOR
  },
  line: {
    'line-color': MAP_PATH_COLOR,
    'line-width': 4
  },
  circle: {
    'circle-radius': 14,
    'circle-stroke-width': 2,
    'circle-stroke-color': MAP_POINT_SELECTED_BORDER,
    'circle-color': MAP_POINT_COLOR
  },
  gps: {
    'circle-color': MAP_POINT_GPS_COLOR
  },
  wifi: {
    'circle-color': MAP_POINT_WIFI_COLOR
  },
  cellid: {
    'circle-color': MAP_POINT_CELLID_COLOR
  },
  cellId: {
    'circle-color': MAP_POINT_CELLID_COLOR
  },
  text: {
    'text-color': MAP_TEXT_COLOR
  },
  textLayout: {
    'text-field': '{title}',
    'text-font': ['Montserrat ExtraBold'],
    'text-anchor': 'center',
    'text-allow-overlap': true,
    'icon-allow-overlap': true
  },
  marker: {
    'icon-image': 'custom-marker',
    'icon-size': 0.5,
    'icon-anchor': 'bottom',
    'icon-allow-overlap': true,
    'icon-ignore-placement': true
  },
  draw: [
    // Selected point
    {
      id: 'gl-draw-selected-point',
      type: 'circle',
      filter: [
        'all',
        ['==', '$type', 'Point'],
        ['==', 'meta', 'feature'],
        ['==', 'active', 'true']
      ],
      paint: {
        'circle-radius': 14,
        'circle-stroke-width': 8,
        'circle-stroke-color': MAP_POINT_SELECTED_BORDER,
        'circle-color': MAP_POINT_COLOR
      }
    },
    // Unselected point
    {
      id: 'gl-draw-point',
      type: 'circle',
      filter: [
        'all',
        ['==', '$type', 'Point'],
        ['==', 'meta', 'feature'],
        ['==', 'active', 'false']
      ],
      paint: {
        'circle-radius': 14,
        'circle-stroke-width': 8,
        'circle-stroke-color': MAP_POINT_BORDER,
        'circle-color': MAP_POINT_COLOR
      }
    },
    // Polygon being drawn
    // line stroke
    {
      id: 'gl-draw-line',
      type: 'line',
      filter: ['all', ['==', '$type', 'LineString'], ['!=', 'mode', 'static']],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': MAP_POLYGON_LINE_COLOR,
        'line-width': 6
      }
    },
    // polygon fill
    {
      id: 'gl-draw-polygon-fill',
      type: 'fill',
      filter: ['all', ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
      paint: {
        'fill-color': MAP_POLYGON_LINE_COLOR,
        'fill-opacity': 0.1
      }
    },
    // polygon outline stroke
    {
      id: 'gl-draw-polygon-stroke-active',
      type: 'line',
      filter: ['all', ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': MAP_POLYGON_LINE_COLOR,
        'line-width': 6
      }
    },
    // vertex point halos
    {
      id: 'gl-draw-polygon-and-line-vertex-halo-active',
      type: 'circle',
      filter: [
        'all',
        ['==', 'meta', 'vertex'],
        ['==', '$type', 'Point'],
        ['!=', 'mode', 'static']
      ],
      paint: {
        'circle-radius': 5,
        'circle-color': MAP_POLYGON_LINE_CIRCLE_COLOR
      }
    },
    // vertex points
    {
      id: 'gl-draw-polygon-and-line-vertex-active',
      type: 'circle',
      filter: [
        'all',
        ['==', 'meta', 'vertex'],
        ['==', '$type', 'Point'],
        ['!=', 'mode', 'static']
      ],
      paint: {
        'circle-radius': 4,
        'circle-color': MAP_POLYGON_LINE_COLOR
      }
    }
  ],
  areaDraw: [
    // Polygon being drawn
    // line stroke
    {
      id: 'gl-draw-line',
      type: 'line',
      filter: ['all', ['==', '$type', 'LineString'], ['!=', 'mode', 'static']],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': MAP_AREA_POLYGON_LINE_COLOR,
        'line-width': 6
      }
    },
    // polygon fill
    {
      id: 'gl-draw-polygon-fill',
      type: 'fill',
      filter: ['all', ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
      paint: {
        'fill-color': MAP_AREA_POLYGON_LINE_COLOR,
        'fill-opacity': 0.1
      }
    },
    // polygon outline stroke
    {
      id: 'gl-draw-polygon-stroke-active',
      type: 'line',
      filter: ['all', ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': MAP_AREA_POLYGON_LINE_COLOR,
        'line-width': 6
      }
    },
    // vertex point halos
    {
      id: 'gl-draw-polygon-and-line-vertex-halo-active',
      type: 'circle',
      filter: [
        'all',
        ['==', 'meta', 'vertex'],
        ['==', '$type', 'Point'],
        ['!=', 'mode', 'static']
      ],
      paint: {
        'circle-radius': 5,
        'circle-color': MAP_AREA_POLYGON_LINE_CIRCLE_COLOR
      }
    },
    // vertex points
    {
      id: 'gl-draw-polygon-and-line-vertex-active',
      type: 'circle',
      filter: [
        'all',
        ['==', 'meta', 'vertex'],
        ['==', '$type', 'Point'],
        ['!=', 'mode', 'static']
      ],
      paint: {
        'circle-radius': 10,
        'circle-color': MAP_AREA_POLYGON_LINE_COLOR
      }
    }
  ]
};

export default styles;



// WEBPACK FOOTER //
// ./src/utils/mapgl/map.styles.js